const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        padding: 3,
        textAlign: "center"
    },
    messageBox: {
        backgroundColor: "white",
        padding: 4,
        borderRadius: 2,
        boxShadow: 3,
        maxWidth: 500,
        width: "90%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    logo: {
        maxWidth: 200,
        height: "auto",
        mb: 3
    },
    message: {
        mb: 3
    },
    loginButton: {
        textTransform: "none" // Prevent uppercase
    }
};

export default styles;
